import { isEmpty, omit } from 'lodash';
import { ACTION_TYPES } from '../constants';

const tasksToProjectsRelation = (state = {}, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_TASK_REQUEST_SUCCESS:
    case ACTION_TYPES.GET_TASK_BY_IDENTIFIER_REQUEST_SUCCESS:
    case ACTION_TYPES.GET_TASK_BY_IDENTIFIER_LEAN_REQUEST_SUCCESS:
    case ACTION_TYPES.ADD_TASK_SUCCESS:
    case ACTION_TYPES.ADD_TASK_EVENT: {
      const { taskId, task: { projectAndSectionLabelList } = {} } = action.payload || {};

      return {
        ...state,
        [taskId]: projectAndSectionLabelList,
      };
    }
    case ACTION_TYPES.UPDATE_TASK_EVENT: {
      const { taskId, task: { projectAndSectionLabelList, requestStartTime } = {} } = action.payload || {};

      const updatedProjectAndSectionLabelList = {};

      Object.keys(projectAndSectionLabelList).forEach((projectId) => {
        const projectAndSection = projectAndSectionLabelList[projectId];
        if (projectAndSection?.isOutdated) {
          updatedProjectAndSectionLabelList[projectId] = state?.[taskId]?.[projectId];
          return;
        }
        updatedProjectAndSectionLabelList[projectId] = {
          ...projectAndSection,
          lastReorderTime: requestStartTime || new Date().getTime()
        }
      });

      return {
        ...state,
        [taskId]: updatedProjectAndSectionLabelList,
      };
    }
    case ACTION_TYPES.GET_USER_TASKS_REQUEST_SUCCESS: {
      const { tasks = {} } = action.payload;

      const updatedState = Object.values(tasks || {}).reduce(
        (result, task) => ({
          ...result,
          [task?._id]: task?.projectAndSectionLabelList,
        }),
        {},
      );

      return {
        ...state,
        ...(updatedState || {}),
      };
    }
    case ACTION_TYPES.DELETE_TASK_REQUEST:
    case ACTION_TYPES.REMOVE_TASK_EVENT: {
      return omit(state, action?.payload?.taskId);
    }
    case ACTION_TYPES.ADD_TASK_TO_PROJECT_REQUEST_SUCCESS: {
      const { taskId, projectId, sectionId } = action.payload || {};

      const currentState = state[taskId] || {};

      return {
        ...state,
        [taskId]: {
          ...currentState,
          [projectId]: {
            projectId,
            sectionId,
          },
        },
      };
    }
    case ACTION_TYPES.REMOVE_PROJECT_FROM_TASK_SUCCESS: {
      const { projectId, taskId } = action?.payload;

      if (isEmpty(state?.[taskId])) {
        return state;
      }

      return {
        ...state,
        [taskId]: omit(state?.[taskId], projectId),
      };
    }
    case ACTION_TYPES.TASKS_REORDER_EVENT:
    case ACTION_TYPES.TASKS_DRAG_N_DROP_ACTION: {
      const { toSection, taskId, projectId, isSameSection, requestStartTime } = action.payload;

      const currentState = state?.[taskId] || {};

      if (isEmpty(currentState) || isSameSection) {
        return state;
      }

      return {
        ...state,
        [taskId]: {
          ...currentState,
          [projectId]: {
            projectId,
            sectionId: toSection,
            lastReorderTime: requestStartTime || new Date().getTime()
          },
        },
      };
    }
    default: {
      return state;
    }
  }
};

export default tasksToProjectsRelation;
